/** @jsxImportSource theme-ui */
import styled from '@emotion/styled';
import { Flex, get, Box as ThemeUIBox } from 'theme-ui';

export const HoverCell = styled.div`
    &:hover {
        a {
            display: block;
            margin-top: -20px;
        }
    }
    a {
        display: none;
    }
`;

export const StyledFilterElement = styled.div<{ first?: boolean }>`
    display: flex;
    border-radius: ${({ theme }) => get(theme, 'radii.md')};
    align-items: center;
    justify-content: space-evenly;
    background: ${({ theme, first }) => (!first ? get(theme, 'colors.slate.50') : undefined)};
`;

export const Container: React.FC = ({ children, ...props }) => (
    <ThemeUIBox
        variant="segment"
        sx={{
            borderRadius: 'sm',
            overflowY: 'scroll',
            zIndex: 2,
            justifySelf: 'left',
            width: '100%',
            backgroundColor: 'background',
            padding: 2,
            position: 'relative',
            table: {
                tableLayout: 'auto',
                width: '100%',
                overflowX: 'auto',
                whiteSpace: 'nowrap',
            },
            thead: {
                textAlign: 'center',
            },
        }}
        {...props}
    >
        {children}
    </ThemeUIBox>
);
